import axios from 'axios';

import { extractData } from '@/api/ApiHelpers';

import type { ModuleStatusesResponse } from '@/api/ApiTypes';


const moduleStatusesGet = (
	handler: (responseData: ModuleStatusesResponse) => void,
	errorHandler: () => void,
): void => {
	axios.get('/stats/get_module_statuses/').then(extractData(handler)).catch(errorHandler);
};


export default {
	moduleStatusesGet,
};
